import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_TRADEPLUS_URL;

// service
export const validateCart = async (cartItems) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/CartItems/validate`,
      cartItems
    );
    return response.data; // CartValidationResult
  } catch (err) {
    // If backend sends validation issues in 400, extract them
    if (err.response?.status === 400 && err.response?.data) {
      return err.response.data; // still return { isValid: false, invalidItems: [...] }
    }
    throw err; // rethrow network errors
  }
};
